export default "__VITE_ASSET__sP$6ednv__"